import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  CurrencyOptions,
  LanguageOptions,
  PeriodOptions,
} from 'src/app/@Consts';
import { IOnboarding } from 'src/app/@Interfaces';
import { ConfigService } from 'src/app/@Services';

@Component({
  selector: 'onboarding',
  templateUrl: './onboarding.dialog.html',
  styleUrls: ['./onboarding.dialog.scss'],
  standalone: false,
})
export class OnboardingDialog {
  constructor(
    private matDialogRef: MatDialogRef<OnboardingDialog>,
    private configService: ConfigService,
    private http: HttpClient
  ) {}

  protected langOptions = LanguageOptions;
  protected currencyOptions = CurrencyOptions;
  protected periodOptions = PeriodOptions;

  protected form: IOnboarding = {
    tax_number: '',
    invoicing: 0,
    vat_free: false,
    company_name: '',
    hotel_id: 0,
    hotel_name: '',
    id_ntak: '',
    flat_tax: false,
    tax_primary: 0,
    tax_secondary: 0,
    email: '',
    phone: '',
    language: 'HU',
    contact_name: '',
    primary_currency: 'HUF',
    secondary_currency: 'EUR',
    country: 'HU',
    premium: false,
    rooms: 0,
    calendar_sync: false,
    channel_manager: false,
    city: '',
    postcode: '',
    address: '',
    net_price: 0,
    currency: 'HUF',
    period: 'MONTH',
    comment: '',
  };

  public closePanel(): void {
    this.matDialogRef.close();
  }

  public postOnboard(): void {
    this.http
      .post<any>(`${this.configService.server}api/hotels`, this.form)
      .subscribe({
        next: () => {
          console.log('successful onboard');
        },
        error: () => {
          console.log('error posting onboard');
        },
      });
  }
}
